import { ProgramEntityInput } from "../../../services/programs/programs.types";

export const initialValuesProgram: ProgramEntityInput = {
  courses: [],
  description: "",
  program_code: "",
  subject_id: 1,
  title: "",
  grade_id: 1,
};
